import { axiosHelper } from "../utils/axiosHelper";

export async function fetchWFOAttendance(startDate, endDate) {
  return await axiosHelper.get("/api/Activity/Select/Attendance", {
    startDate: startDate,
    endDate: endDate,
  });
}
